import React, {useContext, useState} from "react";
import {
    Box,
    Button,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
    Alert
} from "@material-ui/core";

import {useFormik} from "formik";



import BasicInputField from "../form/BasicInputField";
import {fieldsInitialValues, fieldsValidationSchema, getFields} from "./LoginHandler";
import {BrandContext} from "../../../contexts/BrandContext";
import {ManualLoginContext} from "./ManualLoginContext";
import {LoadingBox} from "../BookingsFlow/BookingsFlowComponents";
import useAuth from "../../../hooks/useAuth";



export default function LoginForm(){
    const brandContext = useContext(BrandContext);
    const loginContext = useContext(ManualLoginContext);
    const {manualLoginGo } = useAuth();
    const formFields = getFields();

    const formik = useFormik({
        initialValues: fieldsInitialValues(),
        validationSchema: fieldsValidationSchema,
        onSubmit: (values) => {
            loginContext.doLogin(values,successCallBack);
        }
    });

    const successCallBack = (data) =>{
        manualLoginGo(data);
    }

    const runLogin = () => {
        formik.handleSubmit();
    }

    const hidePasswordRequested = () => {
        loginContext.setState({
            showPasswordRequested:false
        });
    }

    let validEmail = false;
    if(formik.values.email){
        if(formik.getFieldMeta('email').error === undefined){
            validEmail = true;
        }
    }

    const [showManualLogin,setShowManualLogin] = useState(false);


    return (
        <>
            {loginContext.isLoading ?
                <LoadingBox/>
                :
                <>

                    <Box mt={5}><hr/></Box>
                    <Box mt={5}>
                        <Collapse in={!showManualLogin}>
                            <Button fullWidth variant="outlined" onClick={()=>{setShowManualLogin(true)}}>{brandContext.textContent.loginIgtmAccordionButton}</Button>
                        </Collapse>
                        <Collapse in={showManualLogin}>
                            <Typography variant="h5" align="center">{brandContext.textContent.manualLoginTitle}</Typography>
                            <Typography sx={{color: 'text.secondary'}}>{brandContext.textContent.loginFormIgtmHelperText}</Typography>
                            <form>
                                <Collapse in={loginContext.showFailedLogin}>
                                    <Box p={3}>
                                        <Alert severity="error">{brandContext.textContent.manualLoginfailedLoginMessage}</Alert>
                                    </Box>
                                </Collapse>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12} className="boxyAutoComplete">
                                        <BasicInputField formik={formik} formFields={formFields} fieldName="email" fieldProps={{variant: 'outlined'}}/>
                                        <Grid container spacing={2} mt={1} mb={1}>
                                            <Grid item xs>
                                                <Button
                                                    fullWidth
                                                    size="large"
                                                    variant="outlined"
                                                    disabled={!validEmail}
                                                    onClick={() => {
                                                        loginContext.setState({showPasswordField: true})
                                                    }}
                                                >
                                                    {brandContext.textContent.manualLoginEnterPasswordButtonText}
                                                </Button>
                                            </Grid>
                                            <Grid item xs>
                                                <Button
                                                    fullWidth
                                                    size="large"
                                                    variant="outlined"
                                                    disabled={!validEmail}
                                                    onClick={() => {
                                                        loginContext.requestPassword(formik.values.email);
                                                    }}
                                                >
                                                    {brandContext.textContent.manualLoginGetAPasswordButtonText}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Collapse in={loginContext.showPasswordField}>
                                            <BasicInputField formik={formik} formFields={formFields} fieldName="password" fieldProps={{variant: 'outlined'}}/>
                                            <Box mt={3}>
                                                <Button
                                                    fullWidth
                                                    size="large"
                                                    variant="outlined"
                                                    onClick={runLogin}
                                                >
                                                    {brandContext.textContent.manualLoginButtonText}
                                                </Button>
                                            </Box>
                                        </Collapse>
                                    </Grid>
                                </Grid>
                            </form>
                        </Collapse>
                    </Box>
                    <Dialog open={loginContext.showPasswordRequested} onClose={hidePasswordRequested}>
                        <DialogTitle>{ brandContext.textContent.manualLoginPasswordRequestedTitle }</DialogTitle>
                        <DialogContent>
                            { brandContext.textContent.manualLoginPasswordRequestedBody }
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={hidePasswordRequested}>{brandContext.textContent.closeButton}</Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
            </>
    );

}